import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {SetBasicSettingsType} from "./__graphql-types__/index.ts";

export const SET_BASIC_SETTINGS_MUTATION: GqlOperation<
    SetBasicSettingsType["response"],
    SetBasicSettingsType["variables"]
> = gqlOp(gql`
    mutation SetBasicSettings(
        $kaid: String!
        $nickname: String
        $username: String
        $userLanguage: String
        $region: String
        $birthdate: String
    ) {
        setSettings(
            kaid: $kaid
            nickname: $nickname
            username: $username
            userLanguage: $userLanguage
            region: $region
            birthdate: $birthdate
        ) {
            user {
                id
                nickname
                username
                userLanguage
                region
                birthdate
                homepageUrl
            }
            errors {
                code
            }
        }
    }
`);
